import { RowData } from "./types";
import { getValueWithCurrency } from "@/components/Common/Currency";
import { useLocalizationStore } from "@/stores/localizationStore";

export const grossReservationAmountCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return null;
    }

    const { amount } = data.item;

    return amount ? amount : null;
};

export const GrossReservationAmountCellFormatter = ({ data }: { data: RowData }) => {
    if ("grossReservationAmount" in data) {
        const { currency, grossReservationAmount } = data;
        const locale = useLocalizationStore.getState().getLocale();
        return getValueWithCurrency(grossReservationAmount, currency, locale);
    }

    if (!data.isOrganizer) {
        return "";
    }

    const {
        amount,
        purchase: { currency },
    } = data.item;

    const locale = useLocalizationStore.getState().getLocale();
    return getValueWithCurrency(amount, currency, locale);
};
